/** Étiquette des pays fictifs sur la carte (demande d'Alexis du 11/10/2026) : texte blanc sur fond rouge. Le fond
 *  est une image étirable (coins arrondis gardés, centre étiré) que la carte ajuste au nom (`icon-text-fit`). */

import { tokenColor } from "../../components/theme";

export const COUNTRY_BADGE_IMAGE = "gx-country-badge";

const SIZE = 24;
const RADIUS = 5;
const BORDER = 1.25;

interface BadgeHost {
  hasImage(id: string): boolean;
  addImage(
    id: string,
    image: ImageData,
    options?: {
      pixelRatio?: number;
      stretchX?: [number, number][];
      stretchY?: [number, number][];
      content?: [number, number, number, number];
    },
  ): void;
}

function roundedRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

/** Fond au rouge ennemi (APP-6, jeton « hostile »), liseré blanc qui détache l'étiquette de tous les fonds de
 *  carte. */
export function drawCountryBadge(pixelRatio: number): ImageData {
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(SIZE * pixelRatio);
  canvas.height = Math.round(SIZE * pixelRatio);
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas 2D indisponible");
  ctx.scale(pixelRatio, pixelRatio);
  roundedRect(ctx, BORDER / 2, BORDER / 2, SIZE - BORDER, SIZE - BORDER, RADIUS);
  ctx.fillStyle = tokenColor("hostile");
  ctx.fill();
  ctx.lineWidth = BORDER;
  ctx.strokeStyle = "rgba(255,255,255,0.95)";
  ctx.stroke();
  return ctx.getImageData(0, 0, canvas.width, canvas.height);
}

/** Ajoute le fond des étiquettes des pays (« styleimagemissing ») : coins de `RADIUS` gardés, centre étiré. */
export function provideCountryBadge(map: BadgeHost, id: string): boolean {
  if (id !== COUNTRY_BADGE_IMAGE) return false;
  if (map.hasImage(id)) return true;
  const pixelRatio = Math.min(Math.max(window.devicePixelRatio || 1, 1), 3);
  const edge = Math.round(RADIUS * pixelRatio);
  const far = Math.round((SIZE - RADIUS) * pixelRatio);
  map.addImage(id, drawCountryBadge(pixelRatio), {
    pixelRatio,
    stretchX: [[edge, far]],
    stretchY: [[edge, far]],
    content: [edge, edge, far, far],
  });
  return true;
}
